import { useContext } from 'react';
import configContext from './config-context';

const useConfig = () => useContext(configContext);

export default useConfig;
